<template>
  <f7-app :params="f7Params">
    <side-menu/>
    <f7-view url="/" main>
    </f7-view>
  </f7-app>
</template>

<script>
  import LoginScreen from '@/views/login-screen'
  import marque from '@/assets/img/Aio-Dark-Transparent-Marque-Vector.svg'
  import router from '@/utils/router'
  import SideMenu from '@/components/side-menu'
  import cordovaHelpers from '@/utils/cordova-helpers'

  //TODO: bugTracer.js
  export default {
    name: 'App',
    components: {
      LoginScreen,
      SideMenu,
    },
    computed: {
      f7Params () {
        return {
          id: 'uk.co.getaio.app',
          dialog: {
            title: 'aio*',
          },
          // materialPreloaderHtml: '<span class="aio-asterisk"></span>',
          panel: {
            swipe: 'left',
            swipeActiveArea: 20,
            leftBreakpoint: 800,
          },
          routes: this.routes,
          touch: {
            materialRipple: false,
            tapHold: true,
          },
          sortable: {
            moveElements: false,
          },
          statusbar: {
            androidBackgroundColor: '#4A4949',
            androidOverlaysWebView: false,
            androidTextColor: 'white',
            iosTextColor: 'white',
          },
          iosTranslucentBars: false,

          view: {
            pushState: !this.isDevice,
            pushStateSeparator: '#'
          }
        }
      },
    },
    created () {
      this.$f7ready((f7) => {
        this.$bus.on('invalid-token', this.openLogin)
        this.$bus.on('ajax-start', f7.preloader.show)
        this.$bus.on('ajax-stop', f7.preloader.hide)
        this.$bus.on('push-notification', this.showPushNotification)
        this.$bus.on('init-app', this.init)
        this.$bus.on('resume-app', this.resume)
        this.init()
      })
    },
    methods: {
      async init () {
        if (this.isLoggedIn()) {
          await this.$store.dispatch('fetchUser')
          await this.$store.dispatch('fetchCard')
          await this.$store.dispatch('beta/fetchEnabled')
          await this.$store.dispatch('tags/fetch')
          await this.$store.dispatch('requests/fetchOwn')
          if (this.isManager) {
            this.$store.dispatch('budgets/fetch')
            this.$store.dispatch('requests/fetchManaged')
          }
          if (this.isAdmin) {
            this.$store.dispatch('fetchBilling')
          }
        }
      },
      openLogin () {
        if (this.$f7.views.main.router.currentRoute.url !== this.links.login) {
          this.$f7.views.main.router.navigate(this.links.login)
        }
      },
      async resume () {
        if (this.isLoggedIn()) await this.$store.dispatch('fetchUser')
      },
      showPushNotification (msg) {
        this.$f7.notification.create({
          icon: `<img src="${marque}" alt="aio* marque">`,
          title: 'aio*',
          titleRightText: 'now',
          // subtitle: msg.message,
          text: msg.message,
          closeButton: this.$theme.md,
          closeOnClick: true,
          // closeTimeout: 10000,
        }).open()
        this.$bus.emit('init-app')
        this.$store.dispatch('requests/fetchOwn')
      },
    },
    mixins: [router, cordovaHelpers],
  }
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
  @import '~@/assets/css/levima-icons.css';
  @import '~@/sass/fonts.scss';
  @import '~@/sass/variables.scss';

  @media (min-width: 800px) {
    .view-main .navbar .panel-open {
      display: none;
    }
  }

  :root {
    --f7-color-blue: #00B1E2;
    --f7-theme-color: var(--f7-color-blue);
    --f7-list-bg-color: rgba(0, 0, 0, 0);
    --f7-navbar-text-color: #FFF;
    --f7-navbar-bg-color: rgba(0, 0, 0, 0);
    --f7-navbar-link-color: white;

  }

  .color-blue {
    --f7-theme-color: var(--f7-color-blue);
  }

  html {
    background: $bg-grey;
    background-image: url("~@/assets/img/bg-pattern.svg");
  }

  body {
    margin: auto !important;
    max-width: 1024px;
  }

  html.ios {
    .statusbar {
      background: linear-gradient(to right, $toolbar-charcoal1, $toolbar-charcoal2);
    }
  }

  .ios .list.right-color .item-after, .md .list.right-color .item-after {
    color: $cyan;
  }

  body, #app {
    user-select: none;
    -webkit-user-select: none;
  }

  .notification-icon {
    img {
      height: 20px;
    }
  }

  #framework7-root {
    .preloader-backdrop {
      background: #FFF;
      opacity: 0.5;
    }

    @supports ((-webkit-backdrop-filter: blur(5px)) or (backdrop-filter: blur(5px))) {
      .preloader-backdrop {
        opacity: 1;
        background: none;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      }
    }

    @keyframes spin {
      100% {
        transform: rotate(360deg);
      }
    }

    .preloader-modal {
      background-color: #3E3E3D;
      border-radius: 80px;

      .preloader {
        animation: spin 2s linear infinite;
        background-image: url('~@/assets/img/Aio-Light-Transparent-Marque-Vector.svg');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: 90%;

        .preloader-inner {
          display: none;
        }
      }
    }

    .navbar, .subnavbar {
      background: linear-gradient(to right, $toolbar-charcoal1, $toolbar-charcoal2);
      --f7-button-text-color: white;
    }
  }

  .searchbar .searchbar-input-wrap {
    overflow: hidden;

    input::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
  }
</style>
